import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { GamesGridBlock, GamesGridBlockStatic } from '../GameGridBlock';
import { Category } from '@/api/games';
import { SectionTitle } from '@/components/SectionTitle';
import { useCommonStore } from '@/store';

import { ScResult } from '../../styled';

export const SearchGameCategories = () => {
  const { t } = useTranslation('common');

  const {
    isAuthenticated,
    favoriteGames,
    recentGames,
    pendingFavoriteGames,
    pendingRecentGames,
    gamesByCategories,
    gameCategoriesList,
    getGamesByCategory,
  } = useCommonStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      favoriteGames: state.favoriteGames,
      recentGames: state.recentGames,
      pendingFavoriteGames: state.pendingFavoriteGames,
      pendingRecentGames: state.pendingRecentGames,
      gamesByCategories: state.gamesByCategories,
      gameCategoriesList: state.gameCategoriesList,
      getGamesByCategory: state.getGamesByCategory,
    }))
  );

  useEffect(() => {
    gameCategoriesList &&
      getGamesByCategory(Category.TOP, {
        pageSize: 1,
        staticAmount: true,
      });
  }, [getGamesByCategory, gameCategoriesList]);

  const topGames = useMemo(
    () => gamesByCategories[Category.TOP]?.games || [],
    [gamesByCategories]
  );

  const recentGamesList = useMemo(
    () => (recentGames.length && isAuthenticated ? recentGames : [topGames[0]]),
    [isAuthenticated, recentGames, topGames]
  );

  return isAuthenticated ? (
    <>
      <ScResult>
        <SectionTitle>{t('game.recentlyPlayed')}</SectionTitle>
        <GamesGridBlockStatic
          games={recentGamesList}
          loading={pendingRecentGames}
          isSearchModal
        />
      </ScResult>
      <ScResult>
        <SectionTitle>{t('game.favorites')}</SectionTitle>
        <GamesGridBlockStatic
          games={favoriteGames}
          loading={pendingFavoriteGames}
          isSearchModal
        />
        {!favoriteGames.length && (
          <p className="empty-list">{t('game.emptyFavorites')}</p>
        )}
      </ScResult>
    </>
  ) : (
    <>
      <ScResult>
        <SectionTitle>{t('game.topGames')}</SectionTitle>
        <GamesGridBlock category={Category.TOP} isSearchModal />
      </ScResult>
      <ScResult>
        <SectionTitle>{t('gameCategories.trending')}</SectionTitle>
        <GamesGridBlock category={Category.TRENDING} isSearchModal />
      </ScResult>
    </>
  );
};
